const { __ } = wp.i18n;

// Link to codepen: https://codepen.io/jaymierosen/pen/YazYPK
window.addEventListener('DOMContentLoaded', () => {
	const bubble = document.querySelector('.bubble');
	const splat = document.querySelector('.splat');
	const mouth = document.querySelector('.mouth');
	const image = document.querySelector('.wp-block-mavis-gahdoinks .bubblegum img');

	if (!bubble) {
		return;
	}

	if (window.dataLayer) {
		// Push interaction to GA.
		window.dataLayer.push({
			event: 'mischiefAppear',
			mischiefType: 'Bubblegum',
		});
	}

	bubble.addEventListener('click', () => {
		bubble.style.display = 'none';
		splat.style.display = 'block';
		mouth.style.animation = 'none';
		image.alt = __('POP!!! the bubble burst.', 'mavis');

		if (window.dataLayer) {
			// Push interaction to GA.
			window.dataLayer.push({
				event: 'mischiefInteraction',
				mischiefInteraction: 'click',
				mischiefType: 'Bubblegum',
			});
		}
	});
});
